import React, { Component } from 'react';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withMissingDgrsFilter from '../../common/withMissingDgrsFilter';
import BillingFilter from '../../components/BillingFilter';
import Bugsnag from '../../helpers/bugsnag';

class MissingDgrFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {}
    };
  }

  _onApplyFilter = () => {
    try {
      const { goBack, setMissingDgrsCaseFilter } = this.props;
      const { filterData } = this.state;
      for (const value in filterData) {
        if (filterData[value].length === 0) {
          delete filterData[value];
        }
      }
      setMissingDgrsCaseFilter(filterData);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      this.setState({ filterData: data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearFilter = () => {
    try {
      const { setMissingDgrsCaseFilter } = this.props;
      this.setState({ filterData: {} });
      setMissingDgrsCaseFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { missingDgrsFilter } = this.props;
      this.setState({ filterData: missingDgrsFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      filterData
    } = this.state;
    const { goBack, missingDgrsFilter } = this.props;
    return (
      <section className="filter-section">
        <Header
          actionButton={{ title: 'Apply Search', onClick: this._onApplyFilter }}
          title="Billing"
          goBack={() => onGoBack(goBack)}
        />
        <BillingFilter
          title="Search Missing DGRs"
          filter={{
            sort: true, patient: true
          }}
          previousData={filterData}
          onFilter={(data) => this._onFilter(data)}
          selectedFilter={missingDgrsFilter}
          onClearFilter={this._onClearFilter}
        />
      </section>
    );
  }
}

export default withMissingDgrsFilter(
  withGoBack(
    MissingDgrFilter
  )
);
